import { PageHeader } from "../components/layout/PageHeader";
import { SAMPLE_CONTACTS } from "../lib/sample-data";
import { Plus, Search, Filter, Tag } from "lucide-react";

export default function Contacts() {
  return (
    <div data-testid="contacts-page" className="space-y-8">
      <PageHeader
        kicker="Reach"
        title="Contacts"
        description="Your audience, segmented and ready. Tags, lists, lifecycle stages — built for launch sequences."
        actions={
          <>
            <button className="inline-flex items-center gap-2 px-4 h-11 rounded-xl border border-[var(--pl-border)] text-sm text-[var(--pl-text)] hover:border-[var(--pl-aqua)]/40">
              <Filter className="h-4 w-4" /> Filters
            </button>
            <button
              data-testid="contacts-add-btn"
              className="inline-flex items-center gap-2 px-4 h-11 rounded-xl pl-btn-aqua text-sm"
            >
              <Plus className="h-4 w-4" /> Add Contact
            </button>
          </>
        }
      />

      <div className="flex items-center gap-2 px-3 h-11 rounded-xl border border-[var(--pl-border)] bg-[var(--pl-surface)]/60">
        <Search className="h-4 w-4 text-[var(--pl-text-muted)]" />
        <input
          data-testid="contacts-search"
          placeholder="Search contacts…"
          className="bg-transparent flex-1 text-sm outline-none text-[var(--pl-text)] placeholder:text-[var(--pl-text-muted)]"
        />
      </div>

      <div className="rounded-2xl border border-[var(--pl-border)] bg-[var(--pl-surface)]/60 overflow-hidden">
        <div className="grid grid-cols-12 px-4 py-3 text-[10px] uppercase tracking-[0.18em] text-[var(--pl-text-muted)] border-b border-[var(--pl-border)]">
          <div className="col-span-4">Name</div>
          <div className="col-span-4">Email</div>
          <div className="col-span-3">Tags</div>
          <div className="col-span-1 text-right">Activity</div>
        </div>
        {SAMPLE_CONTACTS.map((c) => (
          <div
            key={c.id}
            data-testid={`contact-${c.id}`}
            className="grid grid-cols-12 px-4 py-3 items-center border-b border-[var(--pl-border)] hover:bg-white/[0.03] transition"
          >
            <div className="col-span-4 flex items-center gap-3">
              <div className="h-8 w-8 rounded-full pl-signature-gradient grid place-items-center text-[#061414] text-xs font-semibold">
                {c.name.split(" ").map((s) => s[0]).slice(0, 2).join("")}
              </div>
              <div className="text-sm text-[var(--pl-text)]">{c.name}</div>
            </div>
            <div className="col-span-4 text-sm text-[var(--pl-text-muted)] truncate">{c.email}</div>
            <div className="col-span-3 flex flex-wrap gap-1">
              {c.tags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] border border-[var(--pl-aqua)]/30 bg-[var(--pl-aqua)]/10 text-[var(--pl-aqua)]"
                >
                  <Tag className="h-3 w-3" /> {t}
                </span>
              ))}
            </div>
            <div className="col-span-1 text-right text-[11px] text-[var(--pl-text-muted)] font-mono">
              {c.lastActivity}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
